import { ClassificationModel } from 'api/dto/Classification.dto';
import {
  DemographicDto,
  DemographicModel,
  mapDemographicDtoToModel,
} from 'api/dto/Demographic.dto';
import { DepartmentDto, DepartmentModel, mapDepartmentDtoToModel } from 'api/dto/Department.dto';

export type ContactListSendDto = {
  type: ContactListType;
  id?: number;
  list?: number[];
};

export type ContactListSendModel = {
  type: number;
  list?: ClassificationModel[] | DepartmentModel[];
};

export function mapContactListSendModelToDto(model: ContactListSendModel): ContactListSendDto {
  return {
    type: model.type,
    list: model.list?.map((elem) => elem.id),
  };
}

export type ContactListDto = {
  type: ContactListType;
  id?: number;
  list?: DepartmentDto[] | DemographicDto[];
};

export type ContactListModel = {
  type: number;
  id?: number;
  list?: DemographicModel[] | DepartmentModel[];
};

export function mapContactListDtoToModel(dto: ContactListDto): ContactListModel {
  return {
    id: dto.id,
    type: dto.type,
    list: dto.list && mapSpecificContactListDtoToModel(dto.type, dto.list),
  };
}

function mapSpecificContactListDtoToModel(
  type: ContactListType,
  list: ContactListDto['list'],
): DemographicModel[] | DepartmentModel[] {
  switch (type) {
    case ContactListType.Demographics:
      return list.map(mapDemographicDtoToModel);
    case ContactListType.Departments:
      return list.map((item) => mapDepartmentDtoToModel(item as DepartmentDto));
    default:
      throw new Error('mapSpecificContactListDtoToModel got unknown type.');
  }
}

export enum ContactListDistributionType {
  Email = 0,
  Kiosk = 1,
}
export enum ContactListType {
  All = 0,
  Departments = 1,
  Demographics = 2,
}
